var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('real-button',{class:_vm.classes,attrs:{"state":_vm.state,"disabled":!_vm.$store.state.obs.connected,"type":"tally"},on:{"click":_vm.toggleRecording,"reghotkey":_vm.registerHotkey}},[_vm._v(" Rec ")])}
var staticRenderFns = []

export { render, staticRenderFns }